// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gy9b","type":"styles_type__1-epd","choices":"styles_choices__32HUC"};